itsoftApp.createModule("scrollActions", ["startLoad"], function () {
    var module = this;
    var registeredPlugin = false;
    var registeredScrollTriggerPlugin = false;
    const getScrollbarWidth = itsoftApp.utils.getScrollbarWidth;
    var headerHeight = itsoftApp.utils.getHeaderHeight();

    const libraries = {
        gsap: {
            name: "gsap",
            queue: [],
            started: false,
            loaded: false,
            scriptMore: "/assets/scripts/gsap/ScrollTrigger.min.js",
            script: "/assets/scripts/gsap/gsap.min.js"
        }
    }

    itsoftApp.modules.windowResize.addEvent(function () {
        headerHeight = itsoftApp.utils.getHeaderHeight();
    });

    var initScrollActions = function (element, scrollTriggerFlag, cb, swiper) { 
        const initScrollExemplar = function () {
            if (!registeredPlugin) {
                registeredPlugin = true;

                if (!registeredScrollTriggerPlugin && scrollTriggerFlag) {
                    gsap.registerPlugin(ScrollTrigger);
                }
            }

            if (cb && typeof cb === "function") {
                cb();
            } else {
                if (element.classList.contains("js-hash-nav")) {
                    let mm = gsap.matchMedia();
                    let links = gsap.utils.toArray("[data-color]");
                        
                    links.forEach((a, index) => {
                        let element = document.querySelector(a.getAttribute("href"));

                        mm.add("(max-width: 1023px)", () => {
                            ScrollTrigger.create({
                                trigger: element,
                                start: "top top+=150px",
                                end: "bottom top+=190px",
                                onToggle: self => self.isActive && setActive(a, index)
                            });
                        });

                        mm.add("(min-width: 1024px)", () => {
                            ScrollTrigger.create({
                                trigger: element,
                                start: "top top+=110px",
                                end: "bottom top+=140px",
                                onToggle: self => self.isActive && setActive(a, index)
                            });
                        });
                    });

                    function setActive(link, index) {
                        links.forEach(el => el.classList.remove("js-active"));

                        mm.add("(max-width: 1023px)", () => {
                            if (Swiper) {
                                Swiper.initedSliders["tabsButtons"].slideTo(index);
                            }
                        });
                        link.classList.add("js-active");
                    }
                }
            }
        }

        new itsoftApp.modules.startLoad.callback(initScrollExemplar, libraries.gsap);
    }

    module.callback = initScrollActions;
});